import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn } from '@angular/router';
import { map, switchMap, take } from 'rxjs';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { selectIsUserMeLoaded, selectUserMe } from '@app/main/user-me/store/user-me/user-me.selectors';
import { getUserMe, getUserMeSuccess, userMeError } from '@app/main/user-me/store/user-me/user-me.actions';

export const userMeGuard: CanActivateFn | CanMatchFn = () => {
  const store = inject(Store);
  const actions = inject(Actions);

  const userInitialized$ = store.select(selectUserMe).pipe(
    map(userMe => !!userMe),
    take(1)
  );

  return store.select(selectIsUserMeLoaded).pipe(
    take(1),
    switchMap(loaded => {
      if (loaded) {
        return userInitialized$;
      }

      store.dispatch(getUserMe());

      return actions.pipe(
        ofType(getUserMeSuccess, userMeError),
        take(1),
        switchMap(() => userInitialized$)
      );
    })
  );
};
